import type { FaireThemeEntity } from "../../entity_types/theme";

export const gilded_beauty_essentials: FaireThemeEntity = {
  token: "gilded-beauty-essentials",
  type: "theme",
  name: "Gilded Beauty Essentials",
  description: "Elevate your lounge's accessory collection with high-shine, 18K gold-plated jewelry that offers a luxury feel without the luxury price tag.",
  teaser: "As a beauty lounge in San Jose, your customers likely appreciate high-quality finishing touches that complement their aesthetic services. These non-tarnish pieces are durable and stylish additions to your retail area.",
  detail: "The additional_context shows multiple gold-plated items in your cart, including the Evereign 18K Gold Knot Necklace and the 18K Gold Plated fringe earrings.",
  bgColor: "#D5E8D4",
  tileBgColor: "#8a7232",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_ut3tbs6mrw",
    "p_xh2ydbj634",
    "p_g7jzm6sy9w",
    "p_drd6s69d23",
    "p_49rwssyr8d",
    "p_zxurf3jtrh",
    "p_xg2xg3ubv9",
    "p_85zuvdfqvw",
    "p_musq843yg5",
    "p_767y9wz68u",
    "p_m8ybpjvqmq",
    "p_cdfr2bj9ks",
    "p_s5kj5vxsjg",
    "p_d6rh6t4jz5",
    "p_35e57a9egy",
    "p_nrg5hxcuy3",
    "p_vezk24xebv",
    "p_uxpdx9rb2w",
    "p_j8f47677zc",
    "p_zbfwgazcex",
    "p_5wtjh9ra82",
    "p_f2g2jwcxa5",
    "p_zfekraekak",
    "p_daxsgsypr7",
    "p_3pcekmbkc4",
    "p_ujyrwsn6w8",
    "p_tpf2apke3k",
    "p_qbhs684zfn",
    "p_cghmrnd49u",
    "p_sqe8wwg25b",
    "p_9ma79tyqtg",
    "p_cynbqbj2ch",
    "p_5tf3mnhbng",
    "p_t52g4jqvpq",
    "p_zmtpk6urpp",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
